import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import Input from "../../components/Input"

import "./index.scss";
// import { NONAME } from "dns";

import { getLogs, loadConfig, updateBotValue, updateCurrentTabStatus } from '../../Redux/Actions/uiActions';

import DOWNLOAD_ICON from '../../../assets/icons/ic_download_blue.png';
import RESTORE_ICON from '../../../assets/icons/ic_restore_blue.png';
import REFRESH_ICON from "../../../assets/icons/ic_refresh.svg";

import { PaginationV3, Modal, ButtonV3, DownloadButtonV5 } from 'react-ui-lib';

import history from '../../Routers/history';
import { PAGE } from "../../Utils/constants";

let fileDownload = require('js-file-download');

class LogsContainer extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            botLogs: [],
            logsCount: 0,
            spinnerStatus: true,
            filterData: {
                "offset": "0",
                "limit": "20"
            },
            pageNumber: 1,
            isOpen: false,
            currentConfigId: null,
            currentConfigVersion: ''
        };
        this.selectedTab = 'logs';
    }

    componentDidMount() {
        this.props.getLogs(this.state.filterData, () => {
            this.setState({ spinnerStatus: false })
        });
        this.selectedTab = window.location.pathname.split('/')[2];
        this.props.updateCurrentTabStatus(this.selectedTab);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.botLogs.length !== this.props.botLogs.length) {
            this.setState({ botLogs: this.props.botLogs, logsCount: this.props.logsCount });
        }
    }

    handlePaginationList = (pageOffset, pageNumber) => {
        this.setState({ spinnerStatus: true });
        let filterData = {
            limit: PAGE.LIST_SIZE,
            offset: (pageNumber - 1) * PAGE.LIST_SIZE
        }
        this.setState({
            filterData
        });
        this.props.getLogs(filterData, () => {
            this.setState({ spinnerStatus: false });
        });
    }

    handleFlashMessage = (data, notifyType) => {
        let elem = notifyType === "error" ? document.getElementById('flash-error') : document.getElementById('flash-success');
        if (elem) {
            elem.innerHTML = JSON.stringify(data);
            elem.style.display = "block";
            setTimeout(() => {
                elem.style.display = "none";
            }, 3000);
        }
    }

    renderDate = (date) => {
        const day = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(new Date(date));
        const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(new Date(date));
        const year = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(new Date(date));
        return `${day}-${month}-${year}`
    }

    renderTime = (dateString) => {
        let date = new Date(dateString);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }

    renderStyle = (index) => {
        if (index === this.state.botLogs.length - 1) {
            return {
                borderBottomLeftRadius: '4px',
                borderBottomRightRadius: '4px'
            }
        }
    }

    downloadConfig = (id) => {
        this.setState({ spinnerStatus: true });
        this.props.loadConfig(id, (response) => {
            if (response.success) {
                let fileText = JSON.stringify(response.data, null, 4);
                let fileName = `${response.data._id}_${new Date().getTime()}.json`;
                fileDownload(fileText, fileName);
                this.setState({ spinnerStatus: false });
            }
        });
    }

    toggleModal = (currState = true) => {
        if (!currState) {
            document.getElementsByTagName('body')[0].style.overflow = 'auto';
            this.setState({ isOpen: false });
        } else {
            this.setState(prevState => ({
                isOpen: !prevState.isOpen
            }));
        }
    };

    renderContent = (formType) => {
        return (
            <div>Are you sure want to restore config ?</div>
        );

    };

    restoreConfigConfirmation = (id, version, operation, sourceName) => {
        if (operation === 'build') {
            this.setState({ currentConfigId: id, currentConfigVersion: version, sourceName });
            this.toggleModal();
        }
    }

    onCancelCallback = () => {
        this.setState({ currentConfigId: null, currentConfigVersion: '' });
        this.toggleModal();
    };

    restoreConfig = () => {
        this.setState({ spinnerStatus: true });
        localStorage.setItem('sourceName', this.state.sourceName || 'webpage');
        this.props.loadConfig(this.state.currentConfigId, (response) => {
            if (response.data) {
                this.props.updateBotValue(response.data, false, this.state.currentConfigVersion);
                history.replace(`/${response.data.botId}/chatbot`);
                this.setState({ spinnerStatus: false });
            }
        });
        this.toggleModal()
    }

    refreshCurrentData = () => {
        this.setState({ spinnerStatus: true });
        this.props.getLogs(this.state.filterData, () => {
            this.setState({ spinnerStatus: false });
        });
    }

    render() {
        const formTitle = 'Restore Config';
        const { isOpen } = this.state;
        const header = {
            title: formTitle,
            closeOnOutsideClick: true,
            isRemoveCloseIcon: false,
            style: {
                // backgroundColor: 'red'
            }
        };
        const footer = {
            onSubmit: (id, operation) => { this.restoreConfig(id, operation) },
            onCancel: this.onCancelCallback,
            submitText: 'Accept',
            cancelText: 'Cancel',
            customStyle: {
                justifyContent: 'flex-end'
            },
            disableSubmit: false,
            disableCancel: false
        };
        const customStyle = {
            maxWidth: '550px'
        };
        const spinnerClass = 'body-blocker-div' + ((this.state.spinnerStatus || this.props.blockedUi) ? ' active' : '');
        const downloadHeader = [
            {key : "user", title : "User"},
            {key : "date", title : "Date"},
            {key : "time", title : "Time"},
            {key : "version", title : "Version"},
            {key : "status", title : "Status"},
        ]
            
        return (
            <>
                <div className={spinnerClass} id='onboardLoadingId'></div>
                <DownloadButtonV5 
                    name={"Export Logs"}
                    downloadProps={{
                        downloadFileName : `BotForge_logs_${new Date().getMilliseconds()}`, 
                    }}
                    headerData={downloadHeader}
                    apiData={this.state.botLogs || []}
                    wrapperStyles={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        transform: "translateY(-2.25rem) translateX(-7rem)",
                    }}
                    nestedKeys={{
                        'user' : [],
                        'date' : [],
                        'time' : [],
                    }}
                    customFormattingApiData={{
                        'user' : (data) => `${data.who} (${data.email})`,
                        'date' : (data) => data ? this.renderDate(data.when) : "--",
                        'time' : (data) => data ? this.renderTime(data.when) : "--",
                    }}
                />
                <ButtonV3 
                    data-botforgelog='refresh' 
                    name="Refresh"
                    title="Refresh"
                    btnStyleType={'secondary'}
                    onClick={()=>{this.refreshCurrentData()}}
                    className="botforge-log-refresh-btn"
                    btnstyle={{}}
                    leftIcon={<img src={REFRESH_ICON} alt="refrshIcon" />}
                />
                {this.state.botLogs.length === 0 && !this.state.spinnerStatus ?
                    <div className="empty-logs">
                        <span>No Logs Present.</span>
                    </div> :
                    <div className="log">
                        <div className="logs-component">
                            <div className="logs">
                                {this.state.botLogs.map((item, index) => {
                                    if (item.operation === 'build') {
                                        return (
                                            <div style={this.renderStyle(index)} key={item._id} className="single-log">
                                                <div
                                                    title={item.email ? `${item.who} (${item.email})` : `${item.who}`}
                                                    className="log-name vertical-line-logs"
                                                >
                                                    {item.email ? `${item.who} (${item.email})` : `${item.who}`}
                                                </div>
                                                <div
                                                    className="log-regex vertical-line-logs"
                                                >
                                                    {
                                                        this.renderDate(item.when)
                                                    }
                                                </div>
                                                <div
                                                    className="log-regex vertical-line-logs"
                                                >
                                                    {
                                                        this.renderTime(item.when)
                                                    }
                                                </div>
                                                <div
                                                    title={item.config.sourceName || 'webpage'}
                                                    className="log-regex vertical-line-logs"
                                                >
                                                    {item.config.sourceName || 'webpage'}
                                                </div>
                                                <div
                                                    title={item.version ? item.version : 'NA'}
                                                    className="log-regex vertical-line-logs"
                                                >
                                                    {
                                                        item.version ? item.version : 'N/A'
                                                    }
                                                </div>
                                                <div
                                                    title={item.status ? item.status : 'NA'}
                                                    className={"log-regex vertical-line-logs" + (item.status === undefined ? '' : (item.status === 'success' || item.status === 'SUCCESS') ? ' no-error': ' has-error')}
                                                    style={{'width': 'calc(33.33333% - 120px)'}}
                                                >
                                                    {
                                                        item.status ? item.status : 'N/A'
                                                    }
                                                </div>
                                                <div
                                                    style={{ cursor: 'pointer' }}
                                                    className="log-email"
                                                >
                                                    <div onClick={() => { this.downloadConfig(item._id) }} className="download-logs">
                                                        <img className="icon" alt='download' src={DOWNLOAD_ICON} />
                                                        <div className="title">Download</div>
                                                    </div>
                                                </div>
                                                <div style={{ cursor: 'pointer' }} className="log-email">
                                                    <div onClick={() => { this.restoreConfigConfirmation(item._id, item.version, item.operation, item.config.sourceName || 'webpage') }} className="restore-logs">
                                                        <img className="icon" alt='restore' src={RESTORE_ICON} />
                                                        <div className="title">Restore</div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                            </div>
                        </div>
                    </div>
                }
                <Modal
                    className="restore-config-modal"
                    isOpen={isOpen}
                    onClose={() => {this.toggleModal(false)}}
                    header={header}
                    footer={footer}
                    customStyle={customStyle}
                >
                    {this.renderContent()}
                </Modal>
                <div className="footer">
                    <PaginationV3
                        title="botBuildLogs"
                        maxCount={this.state.logsCount}
                        pageNumber={this.state.pageNumber}
                        LIST_SIZE = {PAGE.LIST_SIZE}
                        handlePaginationList={this.handlePaginationList}
                        setListPageNumber={pageNumber => this.setState({ pageNumber })}
                    />
                </div>
            </>
        );
    }
}
const mapStateToProps = (state) => {
    // console.log(state)
    return {
        botLogs: state.UiReducer.botLogs ? state.UiReducer.botLogs : [],
        blockedUi: state.UiReducer && state.UiReducer.blockedUi ? state.UiReducer.blockedUi : false,
        logsCount: state.UiReducer.logsCount ? state.UiReducer.logsCount : 0
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getLogs,
        loadConfig,
        updateBotValue,
        updateCurrentTabStatus
    },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(LogsContainer);

